import $ from 'jquery';
import localeEn from '../../../locales/en'
import localeAr from '../../../locales/ar'
import { getGridSelectedObj } from '@/app/shared/grid-functionality/grid-utilities.js';

export function testFunc() {
    alert('shared function');
}
export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}

const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
export const newRecordDisplayTemplate = () => `<div class="norecords-template noshow-template"><img class="nodata-img" src=${require('@/assets/svg/vm/no-data-found.svg')} /> <div>${translation[lang].Common.NoRecordToShow}</div>`;
//export const newRecordSplitTemplate = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/blood-bank/add-new-items.png')} /> <div>${translation[lang].Common.AddNewSplitItems}</div>`;
export const noRecordTemplateTP = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFound.svg')} /> <div>${translation[lang].Common.NoTreatmentPlansFound}</div>`;
export const noRecordTemplate = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFound.svg')} /> <div>${translation[lang].Common.NoDataFound}</div>`;
export const noRecordTemplateGreenNoRecords = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFoundGreen.svg')} /> <div>${translation[lang].Common.NoRecordsToDisplay}</div>`;
export const noRecordToDisplayTemplate = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFound.svg')} /> <div>${translation[lang].Common.NoDataToDisplay}</div>`;
export const noRecordTemplateGreen = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFoundGreen.svg')} /> <div>${translation[lang].Common.NoDataFound}</div>`;
export const noRecordTemplateGreenYet = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFoundGreen.svg')} /> <div>${translation[lang].Common.NoDataFoundYet}</div>`;
export const noRecordTemplateBarcodeGreenYet = () => `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFoundGreen.svg')} /> <div>${translation[lang].Common.EmptyGridBarcode}</div>`;
export const noRecordTemplateVisits = () => `<div class="norecords-template"><img class="nodata-img no-visits" src=${require('@/assets/svg/no_Visit_icon.svg')} /> <div><span class="noVisiisPharmacyFilter">${translation[lang].Common.NoVisits}</span><div class="filterByPharmacy"><span class="">${translation[lang].Common.FilterBy}</span><span class="bold"> ${translation[lang].Common.PatientName}</span><span class=""> ${translation[lang].Common.Or}</span><span class="bold"> ${translation[lang].Common.Id}</span></div></div></div>`
export const headerTemplate = (args) => `<a class="k-link" href="#" tabindex="-1"> <span class="k-custom-header">${args}</span> </a>`

export const noRecordTemplateReceipts = () => `<div class="norecords-template"><img class="nodata-img no-visits" src=${require('@/assets/svg/no_Visit_icon.svg')} /> <div><span class="noVisiisPharmacyFilter">${translation[lang].Common.NoReceipts}</span><div class="filterByPharmacy"><span class="">${translation[lang].Common.FilterBy}</span><span class="bold"> ${translation[lang].Common.ReceiptCode}</span><span class=""> ${translation[lang].Common.Or}</span><span class="bold"> ${translation[lang].Common.DateRange}</span></div></div></div>`
//export const noRecordTemplateVisits = () => `<div class="norecords-template"><img class="nodata-img no-visits" src=${require('@/assets/svg/no_Visit_icon.svg')} /> <div>${translation[lang].Common.NoVisits}</div>`;
export const disableAddBtn = (e) => {
    let addBtn = e.sender.element.find(".k-grid-add").get(0);
    addBtn.setAttribute("disabled", true);
}

export const enableAddBtn = function (e) {
    let addBtn = $(".k-grid-add").get(0) || e.sender.element.find(".k-grid-add").get(0);
    addBtn.removeAttribute("disabled");
}


export const customPlaceholder = function (e) {
    let x;
    x = e.container.find("td[data-placeholder]");
    //let astrisk = $(`<span class="asterisk">*<span>`)
    for (let i = 0; i < x.length; i++) {
        let placeholderValue = x[i].getAttribute('data-placeholder');
        let input = x[i].childNodes;
        input[0].setAttribute('placeholder', placeholderValue);
    }
}

export const getTooltipTilte = function (e) {
    document.querySelectorAll('[role="tooltip"]').forEach(tooltipDiv => {
        tooltipDiv.style.visibility = 'hidden'
    });

    let elem = e.target[0];
    if ((elem.offsetWidth < elem.scrollWidth) || elem.classList.contains('k-button')) {
        e.sender.content[0].parentElement.style.visibility = 'visible'
        return e.target.text();
    } else {
        e.sender.content[0].parentElement.style.visibility = 'hidden'
        return ""
    }
}

//export const showPopupNotification = (msg, type) => {
//    this.popupNotificationWidget.show(msg, type);
//};

//export const confirmMsg = (type, toasterType, translatedKeyVal) => {
//    showPopupNotification('<h6>' + toasterType + '</h6><p>' + translatedKeyVal + '</p>', type);
//}

export const disablePaging = function () {

    $(".k-pager-wrap").addClass("k-state-disabled  disable-filter");
    $("[data-role='columnsorter']").addClass("disable-sort");
    $(".k-pager-sizes").attr("disabled", "disabled").addClass("disable-filter").css('border', 'none');

}

export const enablePaging = function () {
    $(".k-pager-wrap ").removeClass("k-state-disabled  disable-filter");
    $("[data-role='columnsorter']").removeClass("disable-sort");
    $(".k-pager-sizes").removeAttr("disabled", "disabled").removeClass("disable-filter");
}

export const disableActionBtn = function (e) {
    e.sender.wrapper.find(".k-command-cell .k-grid-edit ,.k-command-cell .k-grid-showConfirmPopup").addClass("disable-layer").attr("disabled", "disabled");
}

export const enableActionBtn = function (e) {
    e.sender.wrapper.find(".k-command-cell .k-grid-edit ,.k-command-cell .k-grid-showConfirmPopup").removeClass("disable-layer").removeAttr("disabled", "disabled");
}

export const preventFilterAutocomplete = function (e) {
    let filterCells = e.sender.thead.find('.k-filter-row').find('input');
    filterCells.map((idx, cell) => {
        if ($(cell).data('role') == 'autocomplete') {
            let autocomplete = $(cell).data('kendoAutoComplete')
            autocomplete.setOptions({
                suggest: false,
                delay: 0,
                clearButton: false
            })

            autocomplete.bind('open', function (e) {
                e.preventDefault();
            });
        }
    })
}

export const showDeleteConfirmPopup = function (gridSelector, e, screenObj) {
    let rowObj = getGridSelectedObj(gridSelector, e)
    screenObj._bv__modal.show('modal-scoped')
    screenObj.confirmdata.iconName = 'text-danger fas fa-exclamation-triangle';
    screenObj.confirmdata.headerTitle = screenObj.$i18n.t('Common.Alert');
    screenObj.confirmdata.confirmBtnText = screenObj.$i18n.t('Common.No');
    screenObj.confirmdata.cancelBtnText = screenObj.$i18n.t('Common.Yes');
    screenObj.confirmdata.messageText = screenObj.$i18n.t('Common.DeleteMsg');
    screenObj.confirmdata.itemName = localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? `"${rowObj.EnName}"` : `${rowObj.ArName}"`;
    screenObj.confirmdata.qmark = screenObj.$i18n.t('Common.QuestionMark');
    screenObj.confirmdata.id = rowObj.ID;
    screenObj.confirmdata.modifiedTs = rowObj.ModifiedTS;
}

//export const customGridCommand = [

//        {
//            name: 'edit',
//            text: { cancel: this.$i18n.t('Common.Cancel'), update: this.$i18n.t('Common.Update') },
//            click: this.clickEditRow,
//            template: `<a role="button" class="k-button k-button-icontext k-grid-edit">${this.$i18n.t('Common.Edit')}<img src=${require('@/assets/svg/edit.svg')} /></a>`
//        },
//        {
//            name: "showConfirmPopup",
//            iconClass: 'fas fa-trash-alt',
//            click: this.showConfirmPopup,
//            template: `<a role="button" class='k-grid-showConfirmPopup k-button k-button-icontext k-grid-delete'>${this.$i18n.t('Common.Delete')}<img src=${require('@/assets/svg/delete.svg')} /></a>`
//        }

//]

// removing single dot
export const removeDecimalSingleDot = function (el) {
    let currentValue = el.value;
    let CharArray = currentValue.split("");
    if (CharArray.at(-1) == ".") {
        CharArray.pop()
        let newStringValue = CharArray.join()
        el.value = newStringValue.replace(/,/g, "");
    }
}
// allowDecimal with param to replace directive in grids
export const allowDecimalWithConstraint = function (element, e, allowBeforeDec, allowAfterDec) {

    if (e.keyCode > 31 && (e.keyCode < 48 || e.keyCode > 57) && e.keyCode != 46) {
        e.preventDefault();
    }

    //no dec. point
    if (element.value.indexOf(".") == -1 && element.value.length >= allowBeforeDec && e.keyCode != 46 && e.target.selectionStart >= allowBeforeDec) { // allows only one (.)
        e.preventDefault();
    }

    else if (element.value.indexOf(".") != -1 && e.keyCode == 46) {
        e.preventDefault();
    }

    //has dec. point
    else if (element.value.indexOf(".") != -1) {
        const numbersBeforeDot = e.target.value.split('.')[0];
        const numbersAfterDot = e.target.value.split('.')[1];

        //editing before .  and got to max length
        if (0 <= e.target.selectionStart && e.target.selectionStart <= e.target.value.indexOf(".") && numbersBeforeDot.length >= allowBeforeDec) {
            e.preventDefault();
        }
        //editing after .  and got to max length
        if (e.target.value.indexOf(".") < e.target.selectionStart && e.target.selectionStart <= e.target.value.length && numbersAfterDot.length >= allowAfterDec) {
            e.preventDefault();
        }

    }
}

// allowDecimal with contrain after decimal only
export const allowDecimalWithConstraintAfter = function (element, e, allowAfterDec, allowBeforeDec) {
    if (e.keyCode > 31 && (e.keyCode < 48 || e.keyCode > 57) && e.keyCode != 46) {
        e.preventDefault();
    }

    //no dec. point
    if (element.value.indexOf(".") == -1 && element.value.length >= allowBeforeDec && e.keyCode != 46 && e.target.selectionStart >= allowBeforeDec) { // allows only one (.)
        e.preventDefault();
    }

    else if (element.value.indexOf(".") != -1 && e.keyCode == 46) {
        e.preventDefault();
    }

    //has dec. point
    else if (element.value.indexOf(".") != -1) {
        //const numbersBeforeDot = e.target.value.split('.')[0];
        const numbersAfterDot = e.target.value.split('.')[1];




        //editing after .  and got to max length
        if (e.target.value.indexOf(".") < e.target.selectionStart && e.target.selectionStart <= e.target.value.length && numbersAfterDot.length >= allowAfterDec) {
            e.preventDefault();
        }


    }
}
export const allowEnglishCharacterOnly = function (e) {
    if ((e.keyCode >= 97 && e.keyCode <= 122 || e.keyCode == 32 || e.keyCode >= 65 && e.keyCode <= 90)) {
        return;
    }
    else {
        e.preventDefault();
    }
}
export const allowEnglishCharacterOnlyWithoutSpace = function (e) {
    if ((e.keyCode >= 97 && e.keyCode <= 122 || e.keyCode >= 65 && e.keyCode <= 90)) {
        return;
    }
    else {
        e.preventDefault();
    }
}
export const allowNumberEnglishCharacterOnlyWithoutSpace = function (e) {
    if ((e.keyCode >= 97 && e.keyCode <= 122 || e.keyCode >= 65 && e.keyCode <= 90 || (e.keyCode >= 48 && e.keyCode <= 57))) {
        return;
    }
    else {
        e.preventDefault();
    }
}

export const allowArabicCharacterOnly = function (e) {

    if ((e.keyCode >= 1574 && e.keyCode <= 1610 || e.keyCode == 32 || e.keyCode == 1569 || e.keyCode == 1572 || e.keyCode == 1584)) {
        return;
    }
    else {
        e.preventDefault();
    }
}

export const allowIntegersOnly = function (e) {

    if (!(e.keyCode >= 48 && e.keyCode <= 57)) {
        e.preventDefault();
    }
    else {
        return;
    }
}



export const showPopupNotification = function (headerTitle, content, type) {
    this.popupNotificationWidget.show(`<h6>${headerTitle}</h6><p>${content}</p>`, `${type}`);
};

export const enableFilterRow = function (e) {
    if (!e.sender && typeof e === 'string') {
        $(e).find(".k-filter-row .k-autocomplete,.k-filter-row .k-numeric-wrap,.k-filter-row .k-dropdown,.k-filter-row [data-role='filtercell']").removeClass('disable-filter');
        $(e).find(".k-filter-row .k-autocomplete input,.k-filter-row .k-numeric-wrap input,.k-filter-row .k-dropdown,.k-filter-row [data-role='filtercell'] *").removeAttr("disabled");
        return
    }
    e.sender.wrapper.find(".k-filter-row .k-autocomplete,.k-filter-row .k-numeric-wrap,.k-filter-row .k-dropdown,.k-filter-row [data-role='filtercell']").removeClass('disable-filter');
    e.sender.wrapper.find(".k-filter-row .k-autocomplete input,.k-filter-row .k-numeric-wrap input,.k-filter-row .k-dropdown,.k-filter-row [data-role='filtercell'] *").removeAttr("disabled");
}

export const disableFilterRow = function (e) {
    e.sender.wrapper.find(".k-filter-row .k-autocomplete,.k-filter-row .k-numeric-wrap,.k-filter-row .k-dropdown,.k-filter-row [data-role='filtercell']").addClass('disable-filter');
    e.sender.wrapper.find(".k-filter-row .k-autocomplete input,.k-filter-row .k-numeric-wrap input,.k-filter-row .k-dropdown,.k-filter-row [data-role='filtercell'] *").attr("disabled", "disabled");
}
export const pasteArabicCharacterWithSpaceOnly = function (e) {

    let pastedValue = e.clipboardData.getData('text')
    let regexp = /^[\u0621-\u064A,\s]+$/;
    let result = regexp.test(pastedValue);
    if (result) {
        return result;
    }
    else {
        return e.preventDefault();
    }
}
export const pasteEnglishCharacterWithSpaceOnly = function (e) {

    let pastedValue = e.clipboardData.getData('text')
    let regexp = /^[a-zA-Z,\s]+$/;
    let result = regexp.test(pastedValue);
    if (result) {
        return result;
    }
    else {
        return e.preventDefault();
    }
}
export const pasteEnglishCharacterWithoutSpaceOnly = function (e) {

    let pastedValue = e.clipboardData.getData('text')
    let regexp = /^[a-zA-Z]+$/;
    let result = regexp.test(pastedValue);
    if (result) {
        return result;
    }
    else {
        return e.preventDefault();
    }
}
export const pasteNumberEnglishCharacterWithoutSpaceOnly = function (e) {

    let pastedValue = e.clipboardData.getData('text')
    let regexp = /^[A-Za-z\d]+$/;
    let result = regexp.test(pastedValue);
    if (result) {
        return result;
    }
    else {
        return e.preventDefault();
    }
}
export const pasteNumbersWithTwoDigitsOnly = function (e) {
    let pastedValue = e.clipboardData.getData('text')
    let regexp = /^\d+\.\d{0,2}$/;
    let result = regexp.test(pastedValue);
    if (result) {
        return result;
    }
    else {
        return e.preventDefault();
    }
}

export const pasteNumbersWithThreeDigitsOnly = function (e) {
    let pastedValue = e.clipboardData.getData('text')
    let regexp = /^\d+\.\d{0,3}$/;
    let result = regexp.test(pastedValue);
    if (result) {
        return result;
    }
    else {
        return e.preventDefault();
    }
}

export const pasteDigitOnly = function (e) {

    let pastedValue = e.clipboardData.getData('text')
    let regexp = /^[\d]+$/;
    let result = regexp.test(pastedValue);
    if (result) {
        return result;
    }
    else {
        return e.preventDefault();
    }
}
// paste dynamic number of decimal
export const pasteNumbersWithCustomDigitsOnly = function (e,beforeDecimal ,afterDecimal ) {
    let pastedValue = e.clipboardData.getData('text')
    let strr = `^\\d{0,${beforeDecimal}}(\\.\\d{0,${afterDecimal}})?$`;
    var regexp =  new RegExp(strr) ;
    let result = regexp.test(pastedValue);
    return result ? result : e.preventDefault();
}

//prevent round of filter grid
export const preventRoundFilterGrid = function (arg) {
    arg.element.kendoNumericTextBox({
        format: "n3",
        decimals: 3,
        round: false,
        restrictDecimals: true

    });
}
//not allow entry of special characters
export const notAllowSpecialCharacters = function (e, event) {
    let testEvent = (event === 'keypress' ? e.key : e.clipboardData.getData('text'))
    if (!/[^a-zA-Z0-9\u0621-\u064A ]/.test(testEvent)) {
        return true;
    } else {
        e.preventDefault()
    }
}

